// Fælles kilde til titel/beskrivelse/canonical pr. side — bruges både af appen (ved
// navigation) og af scripts/prerender.mjs (statisk HTML pr. side ved build).
// Ingen imports: data sendes ind, så filen kan køre i både webpack og Node.

const MAX_DESCRIPTION = 160;

export function trimDescription(text) {
  const clean = String(text || "").replace(/\s+/g, " ").trim();
  if (clean.length <= MAX_DESCRIPTION) return clean;
  const cut = clean.slice(0, MAX_DESCRIPTION - 1);
  return `${cut.slice(0, cut.lastIndexOf(" "))}…`;
}

export function normalizePath(pathname) {
  const p = (pathname || "/").split(/[?#]/)[0];
  return p.length > 1 ? p.replace(/\/+$/, "") : "/";
}

/** Meta for en sti, eller notFound-meta hvis stien ikke er en kendt side. */
export function resolvePageMeta(pathname, { seo, posts }) {
  const path = normalizePath(pathname);
  const { origin, name } = seo.site;

  const page = seo.pages.find((p) => p.path === path);
  if (page) {
    return { ...page, canonical: `${origin}${path === "/" ? "/" : path}` };
  }

  const m = path.match(/^\/blog\/([^/]+)$/);
  const post = m && posts.find((p) => p.slug === m[1]);
  if (post) {
    return {
      path,
      title: `${post.title} | ${name}`,
      description: trimDescription(post.excerpt || post.content),
      h1: post.title,
      canonical: `${origin}${path}`,
      post,
    };
  }

  return { ...seo.notFound, path, canonical: null, notFound: true };
}
